export default __webpack_public_path__ + "static/media/Update-Address.82993a48.jpg";